import { MensagensService } from 'max-ng-lib';
import { GenericRoteirizadorService } from 'src/app/core/services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigExibicaoCamposService extends GenericRoteirizadorService {

  constructor(
    private httpClient: HttpClient,
    private mensagensService: MensagensService) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/configExibicaoCampos';
  }

  salvar(configExibicaoCampos) {
    return this.post('/salvar', {
      dados: configExibicaoCampos
    });
  }

  consultarPelaChaveTela(chaveTela) {
    return this.get('/consultarPelaChaveTela', {
      dados: { chaveTela }
    });
  }
}
